import { Injectable } from '@angular/core';
import jwt_decode from "jwt-decode";

export interface Credentials {
  // Customize received credentials here

  fname: string;
  email: string;
  mobile: string;
  token: string;
  lname: string;
  // remember?: boolean;
  id: string;
}

const credentialsKey = 'credentials';
/**
 * Provides storage for authentication credentials.
 * The Credentials interface should be replaced with proper implementation.
 */
@Injectable({
  providedIn: 'root',
})
export class CredentialsService {
  private _credentials: Credentials | null = null;
  // verified:any;
  decoded:any
  tokendata:any;
  constructor() {
    const savedCredentials =
      sessionStorage.getItem(credentialsKey) ||
      localStorage.getItem(credentialsKey);
      // this.verified = sessionStorage.getItem('verify') || localStorage.getItem('verify');
    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }
  }

  /**
   * Checks is the user is authenticated.
   * @return True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    // this.verified = sessionStorage.getItem('verify') || localStorage.getItem('verify');
    localStorage.getItem(credentialsKey);
    return (!!this.credentials) &&  (!this.checkExpiry());
  }

  public getAccessToken(): any {
    return localStorage.getItem(credentialsKey);
  }

  public getCustomerId(): any {
    let token = JSON.parse(this.getAccessToken());
    if (token != null) return token.id;
    else return null;
  }

  public getToken(): string {
    let token = JSON.parse(this.getAccessToken());
    return token.token;
  }

  /**
   * Gets the user credentials.
   * @return The user credentials or null if the user is not authenticated.
   */
  get credentials(): Credentials | null {
    return this._credentials;
  }

  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param credentials The user credentials.
   * @param remember True to remember credentials across sessions.
   */
  setCredentials(credentials?: Credentials) {
    this._credentials = credentials || null;
    if (credentials) {
      const storage = credentials ? localStorage : sessionStorage;
      sessionStorage.removeItem('sessionid');
      storage.setItem(credentialsKey, JSON.stringify(credentials));
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
    }
  }
  checkExpiry() {
    var _expiry = sessionStorage.getItem("_expiry");
    var expiry = Number(_expiry);
    if(((Math.floor((new Date).getTime() / 1000)) >= expiry)) {
        this.setCredentials();
        sessionStorage.removeItem('_token');
    }
    return ((Math.floor((new Date).getTime() / 1000)) >= expiry);
  }

  get data(): any{
    return this.tokendata;
  }

  set data(val: any){
    this.tokendata = val;
    console.log(this.tokendata);
  }
}
